// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3ReSs","cell":"ColumnAccessor_cell__1kJB9","firstCellAccent":"ColumnAccessor_firstCellAccent__Ejp0g"};